const getRulesetDetailRequest = (queryParams) => {
  return queryParams?.rulesetId?.id;
};

export default getRulesetDetailRequest;
